(function () {
    'use strict';
    angular
        .module('plagiat2017App')
        .constant('TRANSLATION_KEYS', {
                dictionaryLanguage: 'dictionary.language.'
            }
        );
})();
